import { ReactComponent as Icon } from "../icons/gala.svg";

const Gala = ({color, wth, curs, clickFunc}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, height: wth, marginTop: "5px", cursor: curs})} onClick={clickFunc}/>
    </div>
  );
};

export default Gala;